import { __ } from '../i18n/vsme';

export const CABINET_FISCAL_PERIOD_REQUIRED = 'cabinet_fiscal_period_required';

type WpRestErrorPayload = {
  code?: string;
  message?: string;
  data?: { message?: string };
};

export class HubApiError extends Error {
  readonly code: string | null;

  readonly status: number;

  constructor(message: string, code: string | null, status: number) {
    super(message);
    this.name = 'HubApiError';
    this.code = code;
    this.status = status;
  }
}

export const isHubApiError = (error: unknown): error is HubApiError => error instanceof HubApiError;

export const isCabinetFiscalPeriodRequiredError = (error: unknown): boolean =>
  isHubApiError(error) && error.code === CABINET_FISCAL_PERIOD_REQUIRED;

export const extractHubErrorFromPayload = (
  payload: unknown,
  status: number,
  fallbackMessage: string,
  sanitizeMessage?: (message: string, status: number) => string,
): HubApiError => {
  const parsed = payload as WpRestErrorPayload;
  const code = typeof parsed?.code === 'string' ? parsed.code : null;
  let message = typeof parsed?.message === 'string' && parsed.message !== ''
    ? parsed.message
    : fallbackMessage;

  if (
    typeof parsed?.data?.message === 'string'
    && parsed.data.message !== ''
    && message === fallbackMessage
  ) {
    message = parsed.data.message;
  }

  if (sanitizeMessage) {
    message = sanitizeMessage(message, status);
  }

  return new HubApiError(message, code, status);
};

export const extractHubErrorFromResponse = async (
  response: Response,
  fallbackMessage: string,
  sanitizeMessage?: (message: string, status: number) => string,
): Promise<HubApiError> => {
  const payload = await response.json().catch(() => null);
  return extractHubErrorFromPayload(
    payload,
    response.status,
    fallbackMessage,
    sanitizeMessage,
  );
};

export const hubApiFallbackMessage = (status: number): string => {
  if (status === 400) {
    return __('Requête invalide.');
  }
  if (status === 401) {
    return __('Authentification requise ou session expirée.');
  }
  if (status === 403) {
    return __('Accès refusé.');
  }
  if (status >= 500) {
    return __('Le service est momentanément indisponible. Réessayez plus tard.');
  }
  return __('Une erreur est survenue.');
};
